import React from 'react'
import { Divider } from 'antd'
import { FormikProps } from 'formik'

import { initialValues } from './initial-values'
import UserAddress from './user-address'
import UserAirInfo from './user-air-info'
import UserBasic from './user-basic'
import UserContacts from './user-contacts'
import UserInfo from './user-info'
import UserVehicleInfo from './user-vehicle-info'
import UserBasicTitle from './user-basic-title'

type Props = {
  formikProps: FormikProps<typeof initialValues>
}

export default function UserEditForm({ formikProps }: Props): JSX.Element {
  return (
    <>
      <UserBasicTitle />
      <UserBasic formikProps={formikProps} />
      <Divider />
      <UserAddress formikProps={formikProps} />
      <Divider />
      <UserVehicleInfo formikProps={formikProps} />
      <Divider />
      <UserAirInfo formikProps={formikProps} />
      <Divider />
      <UserContacts formikProps={formikProps} />
      <Divider />
      <UserInfo formikProps={formikProps} />
    </>
  )
}
